/**
 * Aviso de "Enviar" e "Reutilizar" dos checklists de documentos do portal.
 *
 * Não há armazenamento de arquivo nem rota de documentos em
 * `apps/api/src/modulos/`: nenhum botão pode fingir que o arquivo foi
 * recebido. Mesmo tom dos avisos de `operacao/comum/cadastroIndisponivel.ts`
 * (CLAUDE.md, "Regras de interface", item 8).
 */
export const AVISO_DE_ENVIO_INDISPONIVEL = {
  title: 'Envio de documentos ainda não disponível',
  description:
    'Estamos preparando esta funcionalidade. Em breve você poderá enviar seus documentos por aqui.',
} as const;
